// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FormTitle-module__titleText___AMRX- {\n  font-size: 20px;\n  font-family: \"Hiragino Sans\", \"Hiragino Kaku Gothic ProN\", Meiryo, \"sans-serif\";\n  font-weight: 500;\n  color: #444444;\n  max-width: 280px;\n  text-align:left\n}\n\n.FormTitle-module__title___sVSmp {\n  margin-left: 10px;\n}\n\n.FormTitle-module__content___oKO7s {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  max-width: 310px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleText": "FormTitle-module__titleText___AMRX-",
	"title": "FormTitle-module__title___sVSmp",
	"content": "FormTitle-module__content___oKO7s"
};
export default ___CSS_LOADER_EXPORT___;
